module.exports = __webpack_public_path__ + "img/samsung-galaxy-j7.76972bf4.jpg";